module.exports = __webpack_public_path__ + "static/screenshot4-195c16fcca48b313c3c24c3e3f0c155e.png";